<!--suppress JSUnresolvedReference -->
<script>
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     tag?: string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     padding?: boolean | string,
     *     rounded?: boolean | string,
     *     bg?: boolean | string,
     *     border?: boolean | string,
     *     shadow?: boolean | string,
     *     wrapper?: boolean | string,
     *     center?: boolean | string,
     *     addClass?: string,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let {
        tag = 'section',
        mt = 0,
        mb = 0,
        padding = false,
        rounded = false,
        bg = false,
        border = false,
        shadow = false,
        wrapper = false,
        center = false,
        addClass = '',
        children,
    } = $props();

    /** @type {{ [key: string]: string }} */
    const allowedTags = {
        section: 'section',
        article: 'article',
        aside: 'aside',
        div: 'div',
        fieldset: 'fieldset',
        figure: 'figure',
        p: 'p',
        dl: 'dl',
    };

    const thisTag = $derived(allowedTags[ValueService.toStringSingleLine(tag)] ?? 'section');

    const useClasses = $derived.by(() => {
        const classes = [
            'lySection',
            'block',
            'relative',
            'w-full',
            'mt-' + (mt === true ? '4' : ValueService.toUInt(mt)),
            'mb-' + (mb === true ? '4' : ValueService.toUInt(mb)),
            ValueService.toBool(center) ? 'mx-auto' : 'mx-0',
            ValueService.toBool(padding) ? 'pt-4 px-4 pb-5' : 'p-0',
            ValueService.toBool(rounded) ? 'rounded-lg' : 'rounded-none',
            ValueService.toBool(shadow) ? 'shadow-lg' : 'shadow-none',
            ValueService.toBool(wrapper) ? 'max-w-320' : '',
        ];

        // -
        let color = null;
        let intensive = null;
        if (bg === true) {
            color = 'black';
            intensive = 'o50';
        } else if (ValueService.hasValue(bg)) {
            // 'black' || 'black-100' || 'black-o100'
            const parts = ValueService.toStringSingleLine(bg).split('-');
            color = parts[0];
            if (parts.length > 1) {
                intensive = parts.slice(1).join('-');
            }
        }

        // -
        if (ValueService.toBool(border)) {
            classes.push('border', 'border-' + (color ?? 'black') + '-o500');
        }

        if (color !== null) {
            classes.push('bg-' + color + '-' + (intensive ?? 'o100'));
        }

        const extra = ValueService.toStringSingleLine(addClass);

        if (extra !== '') {
            classes.push(extra);
        }

        return classes.join(' ');
    });
</script>

<svelte:element this={thisTag} class={useClasses}>
    {@render children?.()}
</svelte:element>
